import { Button, DatePicker, Divider, Form, Radio } from 'antd';
import { filter, map } from 'lodash';
import React, { useEffect } from 'react';
import {
  DATE_FORMATS,
  DELIVERY_TYPE_OPTIONS,
  ORDER_STATUS,
} from '../../../../../common/constants';
import CitySelectFilter from '../../../../../components/CitySelectFilter';
import ModalComponent from '../../../../../components/ModalComponent';
import SelectComponent from '../../../../../components/SelectComponent';
import useRetainedTableState from '../../../../../hooks/useRetainedTableFilterState';
import LibraryPincodeSelect from '../../../../../modules/lists/modules/library/components/LibraryPincodeSelect';
import LibrarySelect from '../../transfer/components/LibrarySelect';

const { Item } = Form;
const { RangePicker } = DatePicker;
const { Group } = Radio;

const AllFilterOrderModal = ({
  isModalOpen,
  setIsModalOpen,
  onFinish,
  finalWhereFilters,
  setFinalWhereFilters,
  isNewPath,
  isCombinedOrder = false,
  finalWhereFiltersRef = null,
  hideStatus = false,
  isAssignDelPartnerTab = false,
  isAdmin,
  tableFilterKey = null,
}) => {
  const [form] = Form.useForm();
  const { saveRetainedFilterState } = useRetainedTableState();

  const handleReset = () => {
    setIsModalOpen(false);
    form?.resetFields();
    setFinalWhereFilters();
    if (finalWhereFiltersRef) {
      // eslint-disable-next-line no-param-reassign
      finalWhereFiltersRef.current = null;
    }
    if (tableFilterKey)
      saveRetainedFilterState([tableFilterKey], {
        filters: null,
      });
    form?.submit();
  };

  useEffect(() => {
    form?.setFieldsValue({
      ...finalWhereFilters,
      createdAt: [
        finalWhereFilters?.createdAt?.from,
        finalWhereFilters?.createdAt?.to,
      ],
      deliveredOn: [
        finalWhereFilters?.deliveredOn?.from,
        finalWhereFilters?.deliveredOn?.to,
      ],
      status: finalWhereFilters?.status,
      deliveryType: finalWhereFilters?.deliveryType,
      pincodes: finalWhereFilters?.pincodes,
    });
  }, [isModalOpen]);

  // eslint-disable-next-line no-nested-ternary
  const orderStatus = isNewPath
    ? map(
        filter(
          ORDER_STATUS,
          (item) =>
            item?.value === ORDER_STATUS?.PLACED?.value ||
            item?.value === ORDER_STATUS?.CONFIRMED?.value,
        ),
        (item) => ({ label: item?.text, value: item?.value }),
      )
    : isAssignDelPartnerTab
    ? map(
        filter(
          ORDER_STATUS,
          (item) =>
            item?.value === ORDER_STATUS?.READY_TO_SHIP?.value ||
            item?.value === ORDER_STATUS?.CONFIRMED?.value,
        ),
        (item) => ({ label: item?.text, value: item?.value }),
      )
    : map(ORDER_STATUS, (item) => ({ label: item?.text, value: item?.value }));

  return (
    <>
      <ModalComponent
        open={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
        title="Filter"
        forceRender
        destroyOnClose
        footer={null}
      >
        <Divider />
        <div className="mb-16">
          <Form
            form={form}
            onFinish={onFinish}
            autoComplete="off"
            layout="vertical"
          >
            {!isCombinedOrder && (
              <>
                <Item label="Delivery Type" name="deliveryType">
                  <Group options={DELIVERY_TYPE_OPTIONS} />
                </Item>
                <Item label="Pincode" name="pincodes">
                  <LibraryPincodeSelect isIdAsValue />
                </Item>
              </>
            )}
            {isAdmin && !isCombinedOrder && (
              <Item label="Library  Name" name="name">
                <LibrarySelect />
              </Item>
            )}
            <Item label="Placed On" name="createdAt">
              <RangePicker
                format={DATE_FORMATS?.REGULAR}
                className="full-width"
                popupClassName="picker-with-scroll"
                placeholder={['From Date', 'To Date']}
              />
            </Item>
            {!isCombinedOrder && (
              <Item label="Delivered On" name="deliveredOn">
                <RangePicker
                  format={DATE_FORMATS?.REGULAR}
                  className="full-width"
                  popupClassName="picker-with-scroll"
                  placeholder={['From Date', 'To Date']}
                />
              </Item>
            )}
            {!hideStatus && (
              <Item label="Status" name="status">
                <SelectComponent
                  showSearch={false}
                  placeholder="Select Status"
                  mode="multiple"
                  options={orderStatus}
                  maxTagCount={false}
                />
              </Item>
            )}
            {isAdmin && !isCombinedOrder && (
              <Item label="City" name="city">
                <CitySelectFilter allCities />
              </Item>
            )}
          </Form>
          <div className="d-flex justify-end">
            <Button htmlType="submit" onClick={handleReset} className="mr-8">
              Reset
            </Button>
            <Button key="submit" type="primary" onClick={form?.submit}>
              Apply
            </Button>
          </div>
        </div>
      </ModalComponent>
    </>
  );
};

export default AllFilterOrderModal;
